module.exports = __webpack_public_path__ + "img/CrewFamilyXmas.41c03ed3.png";